import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import {URL_BASE} from './mixins'
import { mapGetters } from 'vuex'
Vue.use(Vuex);
// Vue.use(mixins)
export const store=new Vuex.Store({
    // mixins: [mixins], 
    state: {
        auth: false,
        token:"",
        secret_key_token: "Sdw1s9x8@",
        usuario: '',
        dataComisionChip:[],
        dataTipoVendedor:[],
        dataComisionEquipo:[],
        dataDepartamentos:[],
    },
    getters:{
      token: state => state.token
    },
    mutations:{
        iniciar_sesion:(state)=>state.auth=!state.auth,
        acceso_salir:(state)=>state.nivel_acceso="0",
        cerrar_session:(state)=>state.auth=false,
        cambiar_nivelAcceso(state,payload){
            state.nivel_acceso=payload.nivel;
        },
        setComisionChip:(state,payload)=>state.dataComisionChip=payload,
        setComisionEquipo:(state,payload)=>state.dataComisionEquipo=payload,
        setDepartamentos:(state,payload)=>state.dataDepartamentos=payload,
        setToken:(state,payload)=>state.token=payload,
        setUsuario:(state,payload)=>state.usuario=payload,
        setTipoVendedor:(state,payload)=>state.dataTipoVendedor=payload,
    },
    actions:{
        getComisionChip: async (context)=>{
            axios.get(URL_BASE+"comisiones_chip").then(respuesta => {
              context.commit("setComisionChip",respuesta.data.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getComisionEquipo: async (context)=>{
            axios.get(URL_BASE+"comisiones_equipos").then(respuesta => {
              context.commit("setComisionEquipo",respuesta.data.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getDepartamentos: async (context)=>{
            axios.get(URL_BASE+"departamentos").then(respuesta => {
              context.commit("setDepartamentos",respuesta.data.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getTipoVendedor: async (context)=>{
            axios.get(URL_BASE+"tipo_vendedor").then(respuesta => {
              context.commit("setTipoVendedor",respuesta.data.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
    },
    computed: {
      ...mapGetters([
        'token'
      ])
    }
});